import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, Ruler, Sparkles, Smile, Palette, Star } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: <Scissors className="w-8 h-8" data-id="element-359" />,
    title: t('services.s1Title'),
    description: t('services.s1Desc')
  }, {
    icon: <Ruler className="w-8 h-8" data-id="element-360" />,
    title: t('services.s2Title'),
    description: t('services.s2Desc')
  }, {
    icon: <Sparkles className="w-8 h-8" data-id="element-361" />,
    title: t('services.s3Title'),
    description: t('services.s3Desc')
  }, {
    icon: <Smile className="w-8 h-8" data-id="element-362" />,
    title: t('services.s4Title'),
    description: t('services.s4Desc')
  }, {
    icon: <Palette className="w-8 h-8" data-id="element-363" />,
    title: t('services.s5Title'),
    description: t('services.s5Desc')
  }, {
    icon: <Star className="w-8 h-8" data-id="element-364" />,
    title: t('services.s6Title'),
    description: t('services.s6Desc')
  }];
  return <Section className="bg-barber-black" data-id="element-365">
      <div className="text-center mb-16" data-id="element-366">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-barber-text uppercase mb-4" data-id="element-367">
          {t('services.heading1')}{' '}
          <span className="text-barber-gold" data-id="element-368">{t('services.heading2')}</span>
        </h2>
        <div className="w-16 h-1 bg-barber-gold mx-auto" data-id="element-369"></div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-370">
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-barber-gray border border-barber-lightGray p-8 rounded-sm hover:border-barber-gold/50 transition-colors group" data-id="element-371">
            <div className="text-barber-gold mb-6 bg-barber-gold/10 w-16 h-16 flex items-center justify-center rounded-full group-hover:scale-110 transition-transform" data-id="element-372">
              {service.icon}
            </div>
            <h3 className="font-heading text-2xl font-bold text-barber-text uppercase tracking-wide mb-3" data-id="element-373">
              {service.title}
            </h3>
            <p className="text-barber-muted text-lg" data-id="element-374">{service.description}</p>
          </motion.div>)}
      </div>
    </Section>;
}